// Editable configuration. Nothing is invented: leave blank until real values exist.
// Developer documentation (opens in a new tab).
export const DOCS_URL = "https://developers.formaxconnect.in/";

// Contact form API. Set per environment in .env.development / .env.production (REACT_APP_CONTACT_API_URL).
export const CONTACT_API_URL = process.env.REACT_APP_CONTACT_API_URL || "";

export const CONFIG = {
  docsUrl: DOCS_URL,
  sandboxUrl: "", // Sandbox URL
};
export const CONTACT = {
  support: "support@formaxconnect.in",
  partner: "partnership@formaxconnect.in",
  nodal: "nodal@formaxconnect.in",
  address:
    "N0060, Mochpole, Near JR School, Nabapally, Barasat, Kolkata – 700126, West Bengal, India.",
  addressLines: [
    "N0060, Mochpole,",
    "Near JR School,",
    "Nabapally, Barasat,",
    "Kolkata – 700126,",
    "West Bengal, India.",
  ],
  query:
    "N0060, Mochpole, Near JR School, Nabapally, Barasat, Kolkata 700126, West Bengal, India",
  hours: [
    ["Monday – Saturday", "9:00 AM – 6:00 PM IST"],
    ["Sunday", "Closed"],
  ],
};
export const MAPS_URL =
  "https://www.google.com/maps/search/?api=1&query=" +
  encodeURIComponent(CONTACT.query);
export const MAPS_EMBED =
  "https://www.google.com/maps?q=" +
  encodeURIComponent(CONTACT.query) +
  "&output=embed";
export const COMPANY = {
  legal: "FORMAX IT SOLUTIONS PRIVATE LIMITED",
  cin: "U72900WB2018PTC228240",
  gstin: "19AADCF5125F1ZT",
};
export const A = process.env.PUBLIC_URL + "/assets/";

// Legal pages. Keep status "draft" until counsel approves; draft pages show a banner and are not indexed.
export const LEGAL_META = {
  // "draft" keeps legal pages out of search indexes (noindex). Set to "final" at launch once the owner has approved the policies.
  status: "draft",
};

// Merchant Login destination (external portal).
export const MERCHANT_LOGIN_URL = "https://merchant.formaxconnect.in";

// Google Analytics 4 Measurement ID (e.g. "G-XXXXXXXXXX"). Leave empty until supplied by the owner. Loads only after visitor consent.
export const GA_MEASUREMENT_ID = "";
